import { FormattedMessage } from 'react-intl'
import { Link } from '@tanstack/react-router'

import { IconCrownUpgrade } from '@gto/ui/assets'
import { Button } from '@gto/ui/button'
import { RocketLaunchIcon } from '@gto/ui/icons/solid'
import { colors } from '@gto/ui/theme/design-tokens'
import { Typography } from '@gto/ui/typography'

import Bg from '@/assets/images/flash-bg.webp'
import { AbsoluteSuitsOnCorners } from '@/components/absolute-suits-on-corners'
import { sendGaEvent } from '@/gtag'

export const RewardsDescription = () => {
  return (
    <section className="relative mt-12 flex justify-between gap-16 rounded-md border border-divider px-8 py-12 sm:flex-col-reverse sm:justify-center sm:gap-12 sm:px-4">
      <AbsoluteSuitsOnCorners top={-4} />
      <div className="flex flex-col gap-16 sm:gap-12">
        <div className="text-left sm:max-w-none sm:text-center">
          <Typography
            gutterBottom
            className="whitespace-pre-line"
            color="primary"
            component="h2"
            variant="h3"
          >
            <FormattedMessage id="home.rewardsSection.title" />
          </Typography>
          <Typography
            className="font-semibold"
            color="text.primary"
            component="h2"
            variant="h6"
          >
            <FormattedMessage
              id="home.rewardsSection.description"
              values={{
                highlight: (chunks) => (
                  <Typography
                    className="[font-size:inherit] [font-weight:inherit]"
                    color="primary"
                  >
                    {chunks}{' '}
                  </Typography>
                ),
              }}
            />
          </Typography>
        </div>
        <div className="flex flex-col gap-8 pl-6 sm:pl-0">
          <div className="flex flex-col gap-6 sm:gap-12">
            <div className="flex items-start gap-3 sm:flex-col sm:items-center">
              <IconCrownUpgrade
                color={colors.primary.main}
                height={32}
                style={{ flex: '0 0 auto' }}
                width={32}
              />
              <div className="flex flex-col text-left sm:text-center">
                <Typography className="font-bold">
                  <FormattedMessage id="home.rewardsSection.benefits.1.title" />
                </Typography>
                <Typography>
                  <FormattedMessage id="home.rewardsSection.benefits.1.description" />
                </Typography>
              </div>
            </div>
            <div className="flex items-start gap-3 sm:flex-col sm:items-center">
              <RocketLaunchIcon
                color={colors.primary.main}
                height={32}
                style={{ flex: '0 0 auto' }}
              />
              <div className="flex flex-col text-left sm:text-center">
                <Typography className="font-bold">
                  <FormattedMessage id="home.rewardsSection.benefits.2.title" />{' '}
                </Typography>
                <Typography>
                  <FormattedMessage id="home.rewardsSection.benefits.2.description" />
                </Typography>
              </div>
            </div>
          </div>
          <div>
            <Button
              className="sm:w-full"
              color="primary"
              component={Link}
              href="/app/deals"
              size="large"
              variant="contained"
              onClick={() => {
                sendGaEvent({
                  event: 'home_get_your_bonuses_now',
                })
              }}
            >
              <FormattedMessage id="common.controls.getYourBonuses" />
            </Button>
          </div>
        </div>
      </div>
      <div className="mr-12 flex flex-[0_0_auto] items-center justify-center md:mr-0 md:flex-initial">
        <img
          alt="Instant Rewards Flash Background"
          className="w-full max-w-[200px] flex-[0_0_auto] sm:max-w-[150px]"
          loading="lazy"
          src={Bg}
        />
      </div>
    </section>
  )
}
